import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core'
import { FormGroup } from '@angular/forms';
import { OnboardingService } from '../../../../services/onboarding-wizard/onboarding.service'

@Component({
  selector: 'app-sop-settings-step',
  templateUrl: './sop-settings-step.component.html',
  styleUrls: ['./sop-settings-step.component.scss']
})
export class SopSettingsStepComponent implements OnInit, OnChanges {

  @Input() form!: FormGroup
  @Input() companyGroupId!: string
  @Output() saveAndNext = new EventEmitter<void>()
  @Output() discard = new EventEmitter<void>()
  private onboardingService: OnboardingService

  constructor(onboardingService: OnboardingService) {
    this.onboardingService = onboardingService
  }

  moduleList = [
    { key: 'ACTIVITY_TRACKER', label: 'Activity Board' },
    { key: 'GOVERNMENT_BUSINESS_TASK', label: 'GB Tracker' },
    { key: 'QUERIES', label: 'Queries' },
    { key: 'DASHBOARD', label: 'Dashboard' },
    { key: 'OFFLINE_TRACKER', label: 'Offline Tracker' },
    { key: 'CIRCULARS_AND_ANNOUNCEMENTS', label: 'Circulars & Announcements' },
    { key: 'DOCUMENT_REPOSITORY', label: 'Document Repository' },
    { key: 'KNOWLEDGE_BANK', label: 'Knowledge Bank' },
    { key: 'CALENDAR', label: 'Calendar' }
  ]

  categoryList = [
    { key: 'EPF', label: 'EPF' },
    { key: 'ESI', label: 'ESI' },
    { key: 'PT', label: 'PT' },
    { key: 'LABOUR', label: 'Labour' },
    { key: 'OTHER_LLC', label: 'Other LLC' }
  ]

  rmsAdminOptions: any[] = []

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['companyGroupId']?.currentValue) {
      this.loadUnassignedRmsAdmins()
    }
  }

  next() {
    this.saveAndNext.emit()
  }

  loadUnassignedRmsAdmins() {
    this.onboardingService
      .getUnassignedRmsAdmins(this.companyGroupId)
      .subscribe({
        next: users => {
          this.rmsAdminOptions = users?.map(u => ({
            display: `${u.fullName}${u.employeeCode ? ' (' + u.employeeCode + ')' : ''}`,
            value: u.id
          }))
        },
        error: err => {
          console.error('Failed to load RMS admins', err)
        }
      })
  }
}